import { ComponentProps } from "react";

import { classed } from "@/components/classed.config";
import {
  HoverCard,
  HoverCardContent,
  HoverCardPortal,
  HoverCardTrigger,
} from "@/components/elements/HoverCard";
import { Heading } from "@/components/elements/Typography";

const Emph = classed.span("font-semibold");

type ActiveRowDescriptionProps = {
  includeActiveRows?: boolean;
  includeTotalRows?: boolean;
};

export const ActiveRowDescription = (props: ActiveRowDescriptionProps) => {
  const { includeActiveRows = true, includeTotalRows = true } = props;
  return (
    <div className="max-w-sm text-sm">
      <div className="space-y-4">
        {includeActiveRows && (
          <div>
            <Heading as="h3" className="text-sm font-semibold">
              Active Rows
            </Heading>
            <p>
              Data rows <Emph>inserted</Emph> or <Emph>updated</Emph> during a
              Data Source (ETL) or Reverse ETL sync. They typically represent
              10–20% of the total rows synced.
            </p>
            <ul className="my-1 ms-5 list-outside list-disc">
              <li>
                <Emph>Includes</Emph> new and changed rows (each changed row is
                counted only once per month)
              </li>
              <li>
                <Emph>Excludes</Emph> the first 14 days after connector setup
              </li>
            </ul>
          </div>
        )}
        {includeTotalRows && (
          <div>
            <Heading as="h3" className="text-sm font-semibold">
              Total Rows
            </Heading>
            <p>
              All rows inserted or updated during a sync, regardless of when
              they were last updated.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export const ActiveRowTooltipTrigger = ({
  children,
  triggerProps,
  ...props
}: {
  triggerProps?: ComponentProps<typeof HoverCardTrigger>;
  children: JSX.Element;
} & ActiveRowDescriptionProps) => {
  return (
    <HoverCard>
      <HoverCardTrigger {...triggerProps}>{children}</HoverCardTrigger>
      <HoverCardPortal>
        <HoverCardContent className="w-screen xs:max-w-sm">
          <ActiveRowDescription {...props} />
        </HoverCardContent>
      </HoverCardPortal>
    </HoverCard>
  );
};
